var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "2" } },
        [
          _c("v-icon", { staticStyle: { "font-size": "150px" } }, [
            _vm._v("fa-exclamation-circle")
          ])
        ],
        1
      ),
      _c("v-col", { attrs: { cols: "10" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("global.404.title")))]),
        _vm._v(" " + _vm._s(_vm.$t("global.404.content")) + " ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }